<div class="layout-container">
  <fly-header></fly-header>
  <div class="body-container">
    <div class="content-container">
      <fly-navigation
        class="side-nav"
        [navContent]="navigationTree()"></fly-navigation>
      <div class="main-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
  @if (buildTime != null) {
    <fly-footer [flyGarminVersion]="buildTime"> </fly-footer>
  }
</div>
